
import { PuttSituation } from "@/types/golf";

export const shortBunker: PuttSituation = {
  id: 12,
  name: "Bunker court",
  image: "/lovable-uploads/c4115ff1-8247-4ff4-bc79-02202f69616a.png",
  description: "Dans le bunker d'entrainement ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu. Placer une marque au point E=10m dans le bunker entre le bord du green et un trou à 3 m maximum du bord de green. Jouez ensuite 10 balles.",
  distances: [
    { point: "E", distance: 10, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 39 },
    { points: 1, index: 34 },
    { points: 2, index: 29 },
    { points: 3, index: 24 },
    { points: 4, index: 20 },
    { points: 5, index: 17 },
    { points: 6, index: 14 },
    { points: 7, index: 11 },
    { points: 8, index: 8 },
    { points: 9, index: 5 },
    { points: 10, index: 3 },
    { points: 11, index: 1 },
    { points: 12, index: -1 },
    { points: 13, index: -3 },
    { points: 14, index: -5 },
    { points: 15, index: -7 },
    { points: 16, index: -8 },
  ],
};
